import React from 'react'
import { useSelector } from 'react-redux'
import { values } from './../../../../features/dkList/dkListSlice'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { DataTableSortProps } from '../../DocumentKnowledge'
import DocumentKnowledgeService from '../../../../services/DocumentKnowledgeService'

interface CountrySpecificDocsProps {
  showNotUploaded: boolean
  isJapanese: boolean
  sorting: DataTableSortProps
  setSorting: React.Dispatch<React.SetStateAction<DataTableSortProps>>
  isCollapsed: boolean
  collapsedTemplate: (rowData: any, field: any) => {}
}

const CountrySpecificDocs = (props: CountrySpecificDocsProps) => {
  const value = useSelector(values)
  const countrySpecificDocs = props.showNotUploaded
    ? value.countrySpecifics.filter((a: any) => a.link == null)
    : value.countrySpecifics

  const fieldsEnglish = {
    certificationScheme: 'Certification Scheme',
    segment: 'Segment',
    isEssential: 'Is Essential',
    sendToCustomer: 'Send to Customer',
    technology: 'Technology',
    documentNameEn: 'Document Name',
    applicationType: 'Application Type',
    agents: 'Agents',
    remarksEn: 'Remarks English',
    internalRemarks: 'Internal Remarks',
    sign: 'Sign Y/N',
    documentFilename: 'Document Filename',
  }

  const fieldsJapanese = {
    certificationScheme: 'Certification Scheme',
    segment: 'Segment',
    isEssential: 'Is Essential',
    sendToCustomer: 'Send to Customer',
    technology: 'Technology',
    documentNameJpn: 'Document Name (Japanese)*',
    applicationType: 'Application Type',
    agents: 'Agents',
    remarksJpn: 'Remarks Japanese*',
    internalRemarks: 'Internal Remarks',
    sign: 'Sign Y/N',
    documentFilename: 'Document Filename',
  }

  const filenameTemplate = (props: any) => {
    return (
      <button
        type="button"
        className="btn-link"
        onClick={() =>
          DocumentKnowledgeService.downloadR2CDocument(props.id, props.documentFilename)
        }
      >
        {props.documentFilename}
      </button>
    )
  }

  const onSortChange = (sortProps: any) => {
    props.setSorting(current => ({
      ...current,
      countrySpec: {
        column: sortProps.sortField,
        sort: sortProps.sortOrder,
      },
    }))
  }

  return (
    <DataTable
      key={'countrySpecificGrid'}
      loading={value.isLoadingCountrySpecificData}
      className={`ul-table`}
      value={countrySpecificDocs}
      sortMode="single"
      resizableColumns
      removableSort
      responsiveLayout="scroll"
      sortField={props.sorting.countrySpec.column}
      sortOrder={props.sorting.countrySpec.sort}
      onSort={onSortChange}
      showGridlines
      columnResizeMode="expand"
    >
      <Column field="id" header="Id" hidden={true}></Column>
      {Object.entries(props.isJapanese ? fieldsJapanese : fieldsEnglish).map(col => {
        if (col[0] === 'documentFilename')
          return (
            <Column
              key={`countrySpecificGrid-${col[0]}`}
              field={col[0]}
              header={col[1]}
              body={filenameTemplate}
              sortable
            ></Column>
          )

        return (
          <Column
            key={`countrySpecificGrid-${col[0]}`}
            field={col[0]}
            header={col[1]}
            sortable
            body={!props.isCollapsed ? e => props.collapsedTemplate(e, col[0]) : null}
          ></Column>
        )
      })}
    </DataTable>
  )
}

export default CountrySpecificDocs
